// WW-175 · Google plus codes (e.g. QVCR+C92) pin beside the venue, never on it.
export const PLUS_CODE_RE = /\b[A-Z0-9]{4,8}\+[A-Z0-9]{2,3}\b/gi;

export const isPlusCode = (s) => new RegExp(PLUS_CODE_RE.source, "i").test(s || "");

// WW-175.a · strip plus codes and the scraped 'PostalAddress' token, keep the rest.
export const cleanPlace = (s) => (s || "")
  .replace(PLUS_CODE_RE, "")
  .replace(/\bPostalAddress\b/gi, "")
  .split(/\s+-\s+|,/)
  .map((p) => p.trim())
  .filter(Boolean)
  .join(", ");

export function venueMapsUrl(venue, fallbackName = "") {
  const link = (venue?.google_maps_url || "").trim();
  if (/^https?:\/\//i.test(link)) return link;
  const town = (venue?.town || "").trim() || "Nairobi";
  const name = cleanPlace(venue?.name) || cleanPlace(fallbackName);
  const lead = name || cleanPlace(venue?.address);
  if (!lead || lead.toLowerCase() === town.toLowerCase()) return null;
  const parts = [lead];
  const area = (venue?.area || "").trim();
  const areaUseful = area && area.toLowerCase() !== "kenya" && !lead.toLowerCase().includes(area.toLowerCase());
  if (name && areaUseful) parts.push(area);
  if (!parts.join(" ").toLowerCase().includes(town.toLowerCase())) parts.push(town);
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(parts.join(", "))}`;
}
